// TOP LEVEL IMPORTS
import React from 'react';
import DocumentTitle from 'react-document-title';
// APOLLO
import { compose, graphql } from 'react-apollo';
import clientByIdQuery from 'ApolloClient/Queries/clientById';
// ANTD
import Card from 'antd/lib/card';
import message from 'antd/lib/message';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import ClientForm from 'components/forms/ClientForm';
import Icon from 'components/common/Icon';
import ClientHeader from './ClientHeader';
import ClientActionsRow from './ClientActionsRow';
import ClientContracts from './ClientContracts';
import ClientInvoices from './ClientInvoices';
import ClientQuestionnaires from './ClientQuestionnaires';
import ClientSessions from './ClientSessions';
import ClientContactFormEntries from './ClientContactFormEntries';
import ClientDelete from './ClientDelete';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
// APOLLO
import saveClient from 'ApolloClient/Mutations/saveClient';
import clientFragment from '../../ApolloClient/Fragments/clientFragment';

const BackLink = ({ history }) => (
  <div style={{ marginBottom: 15 }}>
    <a onClick={() => history.push('/app/clients')} style={{ fontSize: 16 }}>
      <Icon type="left" style={{ fontSize: 14 }} />
      BACK
    </a>
  </div>
);

const CancelLink = ({ onClick }) => (
  <div style={{ marginBottom: 15 }}>
    <a style={{ fontSize: 16 }} onClick={onClick}>
      <Icon type="left" style={{ fontSize: 14 }} />
      CANCEL
    </a>
  </div>
);

class AppClientDetail extends React.PureComponent {
  state = {
    showEditForm: false,
    loading: false,
  };

  onToggleEdit = () => this.setState({ showEditForm: !this.state.showEditForm });

  postMutationUpdate = (proxy, { data }) => {
    // will update local apollo cache after the mutation. see apollo docs.
    const localData = proxy.readFragment({
      id: this.props.match.params._id,
      fragment: clientFragment,
    });

    proxy.writeFragment({
      fragment: clientFragment,
      data: {
        ...localData,
        ...data.saveClient,
      },
    });
  };

  handleSubmit = async params => {
    this.setState({ loading: true });
    let variables = {
      _id: this.props.match.params._id,
      params,
    };

    let res;

    try {
      res = await this.props.saveClient({ variables, update: this.postMutationUpdate });
    } catch (err) {
      this.setState({ loading: false });
      return console.log(err);
    }

    this.setState({ loading: false });
    message.success('Client changes saved!');
    this.onToggleEdit();
  };

  render() {
    const { currentUser, windowWidth } = this.props;
    const { clientById } = this.props.clientByIdQuery;

    if (!clientById || !currentUser.organization._id || clientById.organizationId !== currentUser.organization._id) {
      return (
        <PageContainer>
          <div>
            <BackLink history={this.props.history} />
            <h1>We are having trouble finding this record....</h1>
          </div>
        </PageContainer>
      );
    }

    if (this.state.showEditForm) {
      return (
        <PageContainer>
          <CancelLink onClick={this.onToggleEdit} />
          <div style={{ width: 550, maxWidth: '100%' }}>
            <Card bodyStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ClientForm loading={this.state.loading} handleSubmit={this.handleSubmit} client={clientById} />
            </Card>
          </div>
        </PageContainer>
      );
    }

    return (
      <DocumentTitle title={clientById ? `HeyNed: ${clientById && clientById.firstName}` : null}>
        <PageContainer>
          <BackLink history={this.props.history} />
          <ClientHeader clientId={clientById._id} client={clientById} onToggleEdit={this.onToggleEdit} />
          <ClientActionsRow
            clientId={clientById._id}
            windowWidth={windowWidth}
            currentUser={currentUser}
            client={clientById}
            history={this.props.history}
          />
          <ClientContracts
            windowWidth={windowWidth}
            clientId={clientById._id}
            client={clientById}
            history={this.props.history}
          />
          <ClientInvoices
            windowWidth={windowWidth}
            clientId={clientById._id}
            client={clientById}
            history={this.props.history}
          />
          <ClientQuestionnaires
            windowWidth={windowWidth}
            clientId={clientById._id}
            client={clientById}
            history={this.props.history}
          />
          <ClientSessions
            currentUser={currentUser}
            windowWidth={windowWidth}
            clientId={clientById._id}
            client={clientById}
            history={this.props.history}
          />
          <ClientContactFormEntries clientId={clientById._id} client={clientById} history={this.props.history} />
          <ClientDelete clientId={clientById._id} />
        </PageContainer>
      </DocumentTitle>
    );
  }
}

let options = props => {
  let variables = {
    _id: props.match.params._id,
  };

  return {
    variables,
  };
};

// EXPORT
// ===================================
export default compose(
  graphql(saveClient, { name: 'saveClient' }),
  graphql(clientByIdQuery, { options, name: 'clientByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'clientByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'clientByIdQuery' }),
)(AppClientDetail);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/index.js